import { useDataFetchingClient } from 'data-fetching-client';
import { GET_CRM_PROPERTY_DEFINITION } from 'automation-ui-formula-editor/data-sources/queries/getCRMPropertyDefinition';
import createReferenceTypeResolver from 'automation-ui-formula-editor/data-sources/hooks/utils/createReferenceTypeResolver';
export default function useResolvePropertyOptionLabelPromise() {
  const client = useDataFetchingClient();
  return async ({
    objectTypeId,
    propertyName,
    value
  }) => {
    const {
      data: propertyData
    } = await client.query({
      query: GET_CRM_PROPERTY_DEFINITION,
      variables: {
        objectType: objectTypeId,
        property: propertyName
      }
    });
    const propertyDefinition = propertyData === null || propertyData === void 0 ? void 0 : propertyData.getCRMPropertyDefinition.property;
    if (propertyDefinition !== null && propertyDefinition !== void 0 && propertyDefinition.externalOptions) {
      const ReferenceResolver = createReferenceTypeResolver({
        property: propertyDefinition,
        objectTypeId
      });
      const reference = await (ReferenceResolver === null || ReferenceResolver === void 0 ? void 0 : ReferenceResolver.api.byId(value));
      if (reference) {
        return reference.label;
      }
    }
    if (propertyDefinition !== null && propertyDefinition !== void 0 && propertyDefinition.options) {
      var _propertyDefinition$o, _propertyDefinition$o2;
      return (_propertyDefinition$o = (_propertyDefinition$o2 = propertyDefinition.options) === null || _propertyDefinition$o2 === void 0 || (_propertyDefinition$o2 = _propertyDefinition$o2.find(({
        value: optionValue
      }) => optionValue === value)) === null || _propertyDefinition$o2 === void 0 ? void 0 : _propertyDefinition$o2.label) !== null && _propertyDefinition$o !== void 0 ? _propertyDefinition$o : null;
    }
    return null;
  };
}